import { render, staticRenderFns } from "./MiniaturaProject.vue?vue&type=template&id=20b582e9&scoped=true&lang=pug&"
import script from "./MiniaturaProject.vue?vue&type=script&lang=js&"
export * from "./MiniaturaProject.vue?vue&type=script&lang=js&"
import style0 from "./MiniaturaProject.vue?vue&type=style&index=0&id=20b582e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b582e9",
  null
  
)

export default component.exports